//Modification provided by the Searchanise team. Contact: feedback@searchanise.io

document.addEventListener('Searchanise.Loaded', function () {
    (function ($) {

        function applyOOSVariants(oosVariants, selectedValue, selectorClass, container) {
            for (let key of Object.getOwnPropertyNames(oosVariants)) {
                if (key === selectedValue) {
                    oosVariants[key].forEach(value => {
                        let element = $(`[data-value="${value}"]`, container);
                        element.addClass('snize-swatch-out-of-stock');
                        element.off('click').on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                        });
                    });
                    break;
                } else {
                    $(`.${selectorClass}`, container).removeClass('snize-swatch-out-of-stock');
                }
            }
        }

        function disableQtySelector(container, item) {
            setTimeout(function () {
                let oosColorVariants = {};
                let oosSizeVariants = {};

                let selectedColor = $('.snize-option-other[name="Color"]', container).length
                    ? $('.snize-option-other[name="Color"]', container).val()
                    : $('.snize-color-swatch-active', container).length
                        ? $('.snize-color-swatch-active', container).attr('data-value')
                        : '';

                let selectedSize = $('.snize-size-active', container).length
                    ? $('.snize-size-active', container).attr('data-value')
                    : '';

                for (let variant of item.shopify_variants) {
                    if (variant.options.Color && variant.options.Size && variant.available == 0) {
                        oosColorVariants[`${variant.options.Color}`] = oosColorVariants[`${variant.options.Color}`] ?? [];
                        oosColorVariants[`${variant.options.Color}`].push(variant.options.Size);
                        oosSizeVariants[`${variant.options.Size}`] = oosSizeVariants[`${variant.options.Size}`] ?? [];
                        oosSizeVariants[`${variant.options.Size}`].push(variant.options.Color);
                    }
                }

                applyOOSVariants(oosColorVariants, selectedColor, 'snize-size', container);
                applyOOSVariants(oosSizeVariants, selectedSize, 'snize-color-swatch', container);

            }, 10);
        }

        $(document).on('Searchanise.QuickViewUpdated', function (event, container, item) {
            disableQtySelector(container, item);
            $('.snize-color-swatch, .snize-size', container).click(() => disableQtySelector(container, item));
            $('.snize-option-other').change(() => disableQtySelector(container, item));
            setTimeout(function () {
                $($('.snize-color-swatch:not(.snize-swatch-out-of-stock), .snize-size:not(.snize-swatch-out-of-stock)', container)[0]).click();
            }, 50);

            if (!$('.snize-qv-sku', container).length) {
                $('.snize-quick-view-description', container).before(`<div class="snize-qv-sku">${item.product_code}</div>`);
            }
        });

    })(window.Searchanise.$);
});